import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const AIWebScrapingPage: React.FC = () => {
  return <ServicePageTemplate slug="ai-web-scraping" />;
};

export default AIWebScrapingPage;
